var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEarmarkEnvelopeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0H16L24 8ZM18 8C16.3431 8 16 7.65685 16 6V2H4C3 2 2 3 2 4V28C2 29 3 30 4 30H20C21 30 22 29 22 28V8H18Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4706 12.1176C12.1765 11.9608 11.8235 11.9608 11.5294 12.1176L5.52941 15.3176C5.20355 15.4914 5 15.8307 5 16.2V17.0169L10.75 20.4669L12 19.7169L13.25 20.4669L19 17.0169V16.2C19 15.8307 18.7965 15.4914 18.4706 15.3176L12.4706 12.1176ZM19 18.1831L14.2218 21.05L19 23.9169V18.1831ZM18.9653 25.0623L12 20.8831L5.03474 25.0623C5.14995 25.4873 5.53846 25.8 6 25.8H18C18.4615 25.8 18.85 25.4873 18.9653 25.0623ZM5 23.9169L9.77817 21.05L5 18.1831V23.9169ZM11.0588 11.2353C11.6471 10.9216 12.3529 10.9216 12.9412 11.2353L18.9412 14.4353C19.5929 14.7829 20 15.4614 20 16.2V24.8C20 25.9046 19.1046 26.8 18 26.8H6C4.89543 26.8 4 25.9046 4 24.8V16.2C4 15.4614 4.4071 14.7829 5.05882 14.4353L11.0588 11.2353Z",
    fill: "#727272",
    stroke: "#727272",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEarmarkEnvelopeOpen);
export default __webpack_public_path__ + "static/media/file-earmark-envelope-open.735df952a5649d6979c44e780a835557.svg";
export { ForwardRef as ReactComponent };